import React from 'react';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import { RISK_COMPLIANCE_BLOCK_STATUS } from '../../dataHandlers/riskComplianceConstants';
import DnBDataCard, { DnBFieldRow } from './DnBDataCard';

export default function HierarchiesConnectionsCard({
  block,
  labels,
  emptyMessage,
  unavailableMessage,
  noDataMessage,
  fetchLabel,
  onFetch,
  onRefresh,
  isFetching,
}) {
  const data = block?.data;

  return (
    <DnBDataCard
      title={labels.title}
      icon={<AccountTreeOutlinedIcon fontSize="small" color="action" />}
      blockStatus={block?.status || RISK_COMPLIANCE_BLOCK_STATUS.EMPTY}
      emptyMessage={emptyMessage}
      unavailableMessage={unavailableMessage}
      noDataMessage={noDataMessage}
      fetchLabel={fetchLabel}
      onFetch={onFetch}
      onRefresh={onRefresh}
      isFetching={isFetching}
    >
      <DnBFieldRow label={labels.globalUltimateParent} value={data?.globalUltimateParent} />
      <DnBFieldRow label={labels.globalUltimateDuns} value={data?.globalUltimateDuns} />
      <DnBFieldRow label={labels.globalUltimateAddress} value={data?.globalUltimateAddress} />
      <DnBFieldRow label={labels.domesticParent} value={data?.domesticParent} />
      <DnBFieldRow label={labels.directParent} value={data?.directParent} />
      <DnBFieldRow label={labels.directParentDuns} value={data?.directParentDuns} />
      <DnBFieldRow label={labels.directParentAddress} value={data?.directParentAddress} />
      <DnBFieldRow
        label={labels.familyTreeRoles}
        value={data?.familyTreeRoles?.length ? data.familyTreeRoles.join(', ') : undefined}
      />
      <DnBFieldRow label={labels.subsidiaries} value={data?.subsidiaries} />
      <DnBFieldRow label={labels.branches} value={data?.branches} />
      <DnBFieldRow label={labels.industrialPlants} value={data?.industrialPlants} />
    </DnBDataCard>
  );
}
